import { AxiosResponse } from "axios";
import { useEffect, useState } from "react";

export function useFetch<Data, Error = any>(
  req: () => Promise<AxiosResponse<Data, Error>>
) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<Data>();
  const [error, setError] = useState<Error>();

  useEffect(() => {
    setLoading(true);
    req()
      .then((res) => setData(res.data))
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, [req]);

  return {
    loading,
    data,
    error,
  };
}
